import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as HeaderIcon } from '../../assets/svg/header.svg';
import { handleOpenMenu } from '../../entities/ComponentsSlice';
import ROUTES from '../../layout/routes';
import style from './HeaderLogo.module.scss';

function HeaderLogo({ color, handleScrollTop, openModelForm }) {
  const dispatch = useDispatch();
  const ariaLabel = 'Moments – жилой комплекс бизнес-класса от Forma';

  return (
    <>
      {color && handleScrollTop && (
        <div className={style.headerLogo}>
          {!openModelForm && (
            <div className={style.svgburger} onClick={() => dispatch(handleOpenMenu(true))} role='button' tabIndex='0'>
              <svg width='32' height='9' viewBox='0 0 32 9' fill='none'>
                <rect x='10' width='22' height='2' rx='1' fill={color} />
                <rect y='7' width='32' height='2' rx='1' fill={color} />
              </svg>
            </div>
          )}
          <Link to={ROUTES.root} onClick={() => handleScrollTop()} aria-label={ariaLabel}>
            <HeaderIcon className={style.svglogo} fill={color} />
          </Link>
        </div>
      )}
      {!color && handleScrollTop && (
        <Link to={ROUTES.root} onClick={() => handleScrollTop()} aria-label={ariaLabel}>
          <HeaderIcon className={style.svglogo} fill='white' />
        </Link>
      )}
      {!color && !handleScrollTop && (
        <Link to={ROUTES.root} aria-label={ariaLabel}>
          <HeaderIcon className={style.svglogo} fill='white' />
        </Link>
      )}
    </>
  );
}

export default HeaderLogo;
